import { useMutation } from "@tanstack/react-query";
import { IUserSubscriptionCancelModel } from "../../models/UserSubscription";
import { UserSubscriptionService } from "../../services/user-subscription.service";

export const useUserSubscriptionMutations = () => {
  const { mutate: cancel } = useMutation<
    any,
    Error,
    { userSubscriptionId: string; model: IUserSubscriptionCancelModel }
  >({
    mutationFn: async ({ userSubscriptionId, model }) =>
      UserSubscriptionService.cancel(userSubscriptionId, model),
  });

  const { mutate: resumeCancellation } = useMutation<any, Error, string>({
    mutationFn: async (userSubscriptionId) =>
      UserSubscriptionService.resumeCancellation(userSubscriptionId),
  });

  const { mutate: setSuspend } = useMutation<
    any,
    Error,
    { userSubscriptionId: string; value: boolean }
  >({
    mutationFn: async ({ userSubscriptionId, value }) =>
      UserSubscriptionService.setSuspend(userSubscriptionId, value),
  });

  const { mutate: change } = useMutation<any, Error, { userId: string; subscriptionId: string }>({
    mutationFn: async ({ userId, subscriptionId }) =>
      UserSubscriptionService.change(userId, subscriptionId),
  });

  return {
    cancel,
    resumeCancellation,
    setSuspend,
    change,
  };
};
